module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAFMCAYAAADsjR3LAAAANElEQVRYhe3IoREAIAwEsC8Cwf5rsCO2xwYciUzVXDvNyEUIIYQQQgghhBDfhxBCiLcjyQEKSANWeR/reAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap_eyes/she_bei_er_ji_bar.png
// module id = xRqI
// module chunks = 2